import { useCookieConsent } from '@/contexts/CookieContext';
import { initializeAnalytics } from '@/lib/firebase';
import { useEffect, useRef } from 'react';

/**
 * Component to handle Firebase Analytics initialization based on cookie consent
 *
 * @component
 * @returns {null} This component doesn't render anything
 */
export const CookieConsentHandler = () => {
  const { consent } = useCookieConsent();
  const analyticsInitialized = useRef(false);

  useEffect(() => {
    // Only initialize analytics once when consent is given
    if (consent?.analytics && !analyticsInitialized.current) {
      (async () => {
        try {
          await initializeAnalytics();
          analyticsInitialized.current = true;

          if (import.meta.env.MODE === 'development') {
            console.info('Firebase Analytics initialized via consent handler');
          }
        } catch (error) {
          console.error('Failed to initialize analytics:', error);
        }
      })();
    }
  }, [consent?.analytics]);

  // This component doesn't render anything
  return null;
};

export default CookieConsentHandler;
